import React, { useMemo } from "react";
// types
import { CroutonIds, ICroutonList, GenericCroutonProps } from "@swiggy-private/cart-types";
import { IColors, ICornerRadius } from "@swiggy-private/dls-web-common/dist/components/types.internal";
// helpers
import { getRemainingDurationInSec } from "../useGenericCrouton/helpers";
// styles
import { Container } from "./styles";
import styles from "./useMagicItemCrouton.scss";
import { isEmpty } from "@swiggy-private/js-utils";

const useMagicItemsCrouton = (croutonList?: ICroutonList[]) => {
    const croutonData = useMemo(
        () => croutonList?.find((crouton) => crouton.type === CroutonIds.MAGIC_ITEMS_TIMER_CROUTON)?.data,
        [croutonList],
    );

    const magicItemContainerNode = useMemo(() => {
        return <Container showTimer={!!croutonData?.showTimer}>{croutonData?.text}</Container>;
    }, [croutonData?.text, croutonData?.showTimer]);

    const payloadForCroutonRegister: GenericCroutonProps = useMemo(() => {
        const remainingDurationInSec = getRemainingDurationInSec(croutonData?.endTimestamp);
        return {
            title: magicItemContainerNode,
            icon: croutonData?.icon || "",
            showTimer: croutonData?.showTimer,
            // intentionally not using isEmpty to avoid falling back to time when
            duration: !isEmpty(croutonData?.endTimestamp) ? remainingDurationInSec : croutonData?.timer,
            durationOfCrouton: croutonData?.timeout,
            timerTextColor: croutonData?.timerTextColor,
            textColor: croutonData?.textColor,
            backgroundColor: croutonData?.backgroundColor as keyof IColors,
            borderRadius: croutonData?.borderRadius as keyof ICornerRadius,
            iconClassName: styles.magicItemCroutonIcon,
        };
    }, [
        croutonData?.icon,
        croutonData?.showTimer,
        croutonData?.endTimestamp,
        croutonData?.timer,
        croutonData?.timeout,
        croutonData?.timerTextColor,
        croutonData?.textColor,
        magicItemContainerNode,
        croutonData?.backgroundColor,
        croutonData?.borderRadius,
    ]);

    return {
        payloadForCroutonRegister,
    };
};

export default useMagicItemsCrouton;
